export default "__VITE_PUBLIC_ASSET__9d9b6320__"